// extracted by mini-css-extract-plugin
module.exports = {"contextMenuItem":"styles_contextMenuItem__1Cpw8","icon":"styles_icon__37gDz","text":"styles_text__rUa-8"};